export default function NoPage() {
  return <h1>404: Whatever you're looking for... It ain't here</h1>;
}
